<template>
    <div class="container-fluid">
        <div class="pt-3 row d-flex justify-content-center align-items-center" v-if="show">
            <div class="alert alert-info h4">
                Új verzió érhető el
                <button class="btn btn-lg btn-success" @click.prevent="update">
                    Frissítés
                </button>
            </div>
        </div>
        <div class="row pt-3 d-flex justify-content-center align-items-center">
            <div
                class="col-12 col-sm-12 col-md-6 col-lg-3"
                v-for="(v,k) in links"
                :key="k"
            >
                <router-link
                    :to="v.link"
                    class="btn btn-block btn-outline-primary btn-lg mb-2"
                >
                    {{ v.text }}
                </router-link>
            </div>
            <div class="col-10">
                <hr>
            </div>
        </div>
        <div class="row d-flex justify-content-center no-gutters pb-3 mb-3">
            <div class="col-12">
                <span class="float-right">
                    <button
                        class="btn"
                        :class="[mainPageGrid == 'list' ? 'btn-secondary' : 'btn-outline-secondary']"
                        @click.prevent="setMainPageGrid('list')"
                    >
                        <i class="fas fa-bars"></i>
                    </button>
                    <button
                        class="btn"
                        :class="[mainPageGrid == 'grid' ? 'btn-secondary' : 'btn-outline-secondary']"
                        @click.prevent="setMainPageGrid('grid')"
                    >
                        <i class="fas fa-th-large"></i>
                    </button>
                </span>
            </div>
            <div
                class="col-12"
                :class="[mainPageGrid == 'list' ? 'col-lg-12' : 'col-lg-6']"
            >
                <p class="h4 pt-1 pb-1">
                    Feladatok
                    <span class="float-right-abs">
                        <button class="btn btn-outline-primary m-1" @click.prevent="loadTasks">
                            Frissít
                        </button>
                    </span>
                </p>
                <task-list :list="tasks"></task-list>
            </div>
            <div
                class="col-12"
                :class="[mainPageGrid == 'list' ? 'col-lg-12' : 'col-lg-6']"
            >
                <p class="h4 pt-1 pb-1">
                    Webes rendelések
                    <span class="float-right-abs">
                        <button class="btn btn-outline-primary m-1" @click.prevent="loadOrders">
                            Frissít
                        </button>
                    </span>
                </p>
                <web-order-list
                    class="col-12"
                    :list="orders"
                >
                </web-order-list>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import taskList from '@/components/tasks/taskList'
import webOrderList from '@/components/webOrders/list'
export default {
    name: 'mainpage',

    components: {
        taskList,
        webOrderList
    },

    data () {
        return {
            show: false,
            tasks: [],
            orders: [],
            links: [
                {
                    link: '/orders/new_order/customer',
                    text: 'Új rendelés'
                },
                {
                    link: '/tasks/add_task',
                    text: 'Új feladat'
                },
                {
                    link: '/inquiring/create',
                    text: 'Új érdeklődő'
                },
                {
                    link: '/customers/search',
                    text: 'Ügyfél keresés'
                },
                {
                    link: '/orders/search',
                    text: 'Rendelés keresés'
                },
                {
                    link: '/weborder/list',
                    text: 'Webes rendelés keresés'
                },
                {
                    link: '/stats/gordulo',
                    text: 'Gördülő átlag'
                },
                {
                    link: '/stats/kimikor',
                    text: 'Ki mikor rendelt utoljára'
                }
            ]
        }
    },

    mounted() {
        this.show = false
        this.req.get('/others/version')
            .then(res => {
                let {ver} = res.data
                if(ver !== undefined && ver.version > this.version) {
                    this.show = true
                }
            })
            .catch(err => console.log(err))
        this.loadTasks()
        this.loadOrders()
    },

    methods: {
        ...mapActions(['setMainPageGrid']),

        update() {
            this.$forceUpdate()
        },

        loadTasks() {
            this.$Progress.start()
            this.req.post('/tasks/gettasks', {
                userid: this.user.azon,
                aktiv: 1,
                h_datum_ig: this.$moment().add(1, 'months').format('YYYY-MM-DD')
            })
                .then(res => {
                    this.tasks = res.data.list
                    this.$Progress.finish()
                    this.isLoading = false
                })
                .catch(err => {
                    this.$Progress.fail()
                    this.isLoading = false
                    toastr.error(err.response.data.text || err)
                })
        },

        loadOrders() {
            this.$Progress.start()
            this.req.get('/orders/ugyfel/list')
                .then(res => {
                    this.orders = res.data.orders
                })
                .catch(err => {
                    this.$Progress.fail()
                    toastr.error(err.response.data || err)
                })
        }
    },

    computed: {
        ...mapGetters(['user','mainPageGrid'])
    }
}
</script>

<style scoped>
.float-right-abs {
    position: absolute;
    top: 0;
    right: 0;

}
</style>



// WEBPACK FOOTER //
// src/components/mainpage.vue